import React from 'react';
import './Item.css';
import { Link } from 'react-router-dom';

const imgUrl = process.env.REACT_APP_ASSET_PATH;

const Item = (props) => {
  const isSoldOut = props.quantity === 0;

  return (
    <div className='item'>
      <Link
        to={`/product/${props.id}`}
        onClick={() => window.scrollTo(0, 0)}  // ✅ Cleaned up — no need for setTimeout + href redirect when Link handles routing
      >
        <div style={{ position: 'relative' }}>
          <img
            src={imgUrl + props.img}
            alt={props.name}
            style={isSoldOut ? { filter: 'grayscale(1) opacity(0.5)' } : {}}
          />
          {isSoldOut && (
            <div style={{
                position: 'absolute', top: 22, right: -28,
                background: '#E24B4A', color: '#fff',
                fontSize: '0.6rem', fontWeight: 500, letterSpacing: '0.04em',
                padding: '5px 5px', transform: 'rotate(35deg)'
            }}>
              SOLD OUT
            </div>
          )}
        </div>
      </Link>

      <p>{props.name}</p>
      <div className="item-prices">
        <div className={isSoldOut ? "item-price-new item-price-soldout" : "item-price-new"}>
          ${props.price}
        </div>
      </div>
    </div>
  );
};

export default Item;